var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('h2',[_vm._v("Seu atendimento foi finalizado!")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('img',{attrs:{"src":'/static/img/checkmark.gif',"alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a93d5b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FinishTicket.vue
// module id = null
// module chunks = 